"use client";

import { IconSearchEmpty } from "@repo/assets/images";
import { MiniSearchSkeleton, SearchItems } from "@repo/components";
import { useTranslations } from "next-intl";
const QuickSearch = ({
  quickSearch,
  isPending,
  debouncedSearchTerm,
  setShowPopOver,
  onClick
}) => {
  const t = useTranslations("Common");
  return <div className="bg-miniSearch-bg top-10 z-50 min-h-64 w-full rounded-b-sm px-3 py-4" data-sentry-component="QuickSearch" data-sentry-source-file="QuickSearch.jsx">
      {isPending ? <MiniSearchSkeleton /> : <>
          {quickSearch?.length ? <>
              <h4 className="font-heading text-miniSearch-heading rtl:font-arabic flex items-center pb-1 text-xl font-medium">
                {t("Search_Result")}
              </h4>
              <SearchItems items={quickSearch} setShowPopOver={setShowPopOver} onClick={onClick} searchTerm={debouncedSearchTerm} />
            </> : <div className="py-10 text-center">
              <IconSearchEmpty className="text-miniSearch-searchNotFoundIconText fill-miniSearch-searchNotFoundIconBg mx-auto" />
              <p className="font-heading text-miniSearch-heading rtl:font-arabic py-2 text-xl font-medium">
                {t("No_Search_Result")}
              </p>
              <p className="text-miniSearch-heading text-sm">
                {t("Couldn_Not_Find_Any_Relevant_Matches_For")}
              </p>
              <p className="py-2 text-xs">&apos;{debouncedSearchTerm}&rsquo;</p>
            </div>}
        </>}
    </div>;
};
export default QuickSearch;